import { Cross, X } from '@phosphor-icons/react';

interface FilePreviewProps {
    files: { name: string; url: string; sha1: string }[];
    fileHoverIndex: any;
    setFileHoverIndex: any;
    handleFileDelete: any;
}

export default function FilePreview({ files, fileHoverIndex, setFileHoverIndex, handleFileDelete }: FilePreviewProps) {
    const chatInputBorderColor = 'border-layout-borderColor';

    return files && files.length > 0 ? (
        <div className="p-2">
            {files.map((file: { name: string; url: string; sha1: string }, index: any) => (
                <div
                    key={index}
                    className="relative inline-block mb-2 mr-2"
                    onMouseEnter={() => setFileHoverIndex(index)}
                    onMouseLeave={() => setFileHoverIndex(-1)}
                >
                    {file.url.startsWith('data:image') ? (
                        <div
                            onClick={() => handleFileDelete(index)}
                            className="w-[70px] h-[70px] bg-chatMessage-image-background flex items-center justify-center mr-2 mb-2 cursor-pointer rounded-xl"
                        >
                            <img src={file.url} alt={file.name} className="max-w-full max-h-full object-cover" />
                        </div>
                    ) : (
                        <div className={`${chatInputBorderColor} border rounded-xl p-3`}>{file.name}</div>
                    )}
                    {fileHoverIndex === index && (
                        <button
                            onClick={() => handleFileDelete(index)}
                            className={`absolute ${
                                file.url.startsWith('data:image') ? 'top-[5px] right-[5px]' : 'top-0 right-0'
                            } p-1 text-white bg-black rounded-full hover-target`}
                            style={{
                                transform: 'translate(50%, -50%)',
                                width: '25px',
                                height: '25px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <X size={24} />
                        </button>
                    )}
                </div>
            ))}
        </div>
    ) : (
        <></>
    );
}
